import useHover from "../hooks/hover";

const Hover = ({ children }) => {
  const [isHovered, eventHandlers] = useHover();
  return children([isHovered, eventHandlers]);
};

export default Hover;
